import { Scrollbar } from 'smooth-scrollbar-react';
import styled from 'styled-components';

// eslint-disable-next-line import/prefer-default-export
export const StyledScrollbar = styled(Scrollbar)<{ marginBottom?: number }>`
  display: none;

  & > :nth-child(1) {
    margin-bottom: ${({ marginBottom }) => `${marginBottom}px`};
  }
`;
